export const FLOW_STEPS = {
  EVENT_SIGNUP_START: 'event-signup-start',
  EVENT_EMAIL_SIGNUP: 'event-email-signup',
  EVENT_EMAIL_LOGIN: 'event-email-login',
  EVENT_EMAIL_RESET: 'event-email-reset',
  EVENT_LOYALTY_ENROLL: 'event-loyalty-enroll',
  EVENT_SIGNUP_END: 'event-signup-end',
} as const;

export type FlowStep = typeof FLOW_STEPS[keyof typeof FLOW_STEPS];

export type LoyaltyUserType = 'existing' | 'new' | 'none';
